import l10n from "@/services/l10n";

export default [
  {
    name: "charts",
    path: "/charts",
    icon: "charts",
    meta: { title: l10n("CHARTS") },
    component: () =>
      import(/* webpackChunkName: "charts" */ "@/pages/Charts/Charts.vue")
  }
];
